import { CoreActionsTypes } from '@protector/entities/core/__legacy__/redux.constants';
import { LoadProperties, LoadPropertiesAreaInfo, LoadPropertiesFailure } from '@protector/entities/property/__legacy__/redux.actions';
import type { Action, SelectEntityType } from '@protector/utils/types';
import { C_LEVEL_REPORT } from 'authentication/constants';
import type { ActionsObservable, StateObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import type { AppState } from 'redux/app-state';
import { concat, of } from 'rxjs';
import { exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { getSelectedCompanyId } from './core.selectors';
import { FakeLoadAll } from './services/analytics/widgets/widgets.actions';

export const requestLoadCompanyData = (action$: ActionsObservable<Action<SelectEntityType>>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType(CoreActionsTypes.SELECT_COMPANY),
    filter(() => !window.location.pathname.includes(C_LEVEL_REPORT)),
    withLatestFrom(state$.pipe(map(getSelectedCompanyId))),
    exhaustMap(([, companyId]) => {
      if (!companyId) {
        return of(LoadPropertiesFailure("There isn't a selected Company"));
      }

      sessionStorage.setItem('company_id', companyId);

      return concat([
        LoadProperties({
          pageable: {
            page: 0,
            size: 10
          },
          query: {
            params: new Map([['company_id', companyId]])
          }
        }),
        LoadPropertiesAreaInfo({
          pageable: {
            page: 0,
            size: 10
          },
          query: {
            params: new Map([['company_id', companyId]])
          }
        }),
        FakeLoadAll()
      ]);
    })
  );
